import { CHART_DEFAULTS, HTML_TAG_REGEX, MARKDOWN_BOLD_REGEX } from './constants';

// Tool callback utilities
const formatToolArguments = ({ tool }) => {
    if (!tool?.arguments) return '';

    const args = typeof tool.arguments === 'string' ? JSON.parse(tool.arguments) : tool.arguments;
    const formattedArgs = Object.entries(args).map(([key, value]) => `**${key}**: ${value}`);

    if (formattedArgs.length <= 1) return formattedArgs[0] ?? '';

    const lastArg = formattedArgs.pop();
    return `${formattedArgs.join(', ')} & ${lastArg}`;
};

export const createToolInitPhrase = ({ t, tool, merge = false }) => {
    const args = formatToolArguments({ tool });
    const phrase = args
        ? t('label_copilot_tool_initializing_with_args', [tool?.name, args])
        : t('label_copilot_tool_initializing', [tool?.name]);

    return { phrases: [phrase], merge };
};

export const createToolDonePhrase = ({ t, tool, merge = false }) => {
    return { phrases: [t('label_copilot_tool_finishing', [tool?.name])], merge };
};

// Text processing utilities
export const removeTags = (text) => {
    return text.replace(HTML_TAG_REGEX, '');
};

export const removeMarkdown = (text) => {
    return text.replace(MARKDOWN_BOLD_REGEX, '$1');
};

export const processLiveMarkdown = (text) => {
    return text.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
};

export const processStaticMarkdown = (textBox) => {
    if (!textBox) return;

    const htmlText = textBox.innerHTML;
    const newText = htmlText.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
    textBox.innerHTML = newText;
};

// Regex utilities
export const getRegexMatch = (text, regex) => {
    const matchArr = text.match(regex);
    if (!matchArr) return '';
    return matchArr?.[2] || '';
};

export const getRegexExec = (text, regex) => {
    const matchArr = regex.exec(text) || [];

    if (!matchArr.length) return {};

    const match = matchArr?.[0] || '';
    const info = matchArr?.[2] || '';

    return { match, info };
};

// Color utilities
export const isColorDark = (rgbColor) => {
    const [r, g, b] = CHART_DEFAULTS.grayscaleWeights;
    const grayscaleValue = r * rgbColor[0] + g * rgbColor[1] + b * rgbColor[2];

    return grayscaleValue < CHART_DEFAULTS.colorThreshold;
};

// String comparison utility
export const getDifference = (str1, str2) => {
    if (!str1) return str2;

    const arr1 = str1.toLowerCase().split('');
    const arr2 = str2.toLowerCase().split('');

    const index = arr2.findIndex((char, i) => char !== arr1[i]);

    return str2.slice(index);
};

// Table utilities
export const tableToCSV = (table, removeTags) => {
    if (!table) return;

    let csvData = [];
    const rows = table.querySelectorAll('tr');

    for (let i = 0; i < rows.length; i++) {
        const cols = rows[i].querySelectorAll('td,th');
        let csvRow = [];

        for (let j = 0; j < cols.length; j++) {
            const text = cols[j].innerHTML || '';
            csvRow.push(removeTags(text));
        }

        csvData.push(csvRow.join(','));
    }

    return csvData.join('\n');
};
